import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';
import TrustpilotStars from './TrustpilotStars';

const ReviewsVerticalElement = ({ element }) => {
  const { replaceTemplates } = useOnboarding();
  const style = applyStyles(element);

  if (!element.reviews || !Array.isArray(element.reviews)) {
    return null;
  }

  return (
    <div className="element-reviews-vertical" style={style}>
      {element.reviews.map((review, index) => (
        <div key={index} className="review-vertical-card">
          {(review.starsCount !== undefined || review.author || review.name) && (
            <div className="review-header">
              {review.starsCount !== undefined && (
                <TrustpilotStars count={parseInt(review.starsCount) || 5} />
              )}
              {(review.author || review.name) && (
                <div className="review-vertical-author">
                  {replaceTemplates(review.author || review.name)}
                </div>
              )}
            </div>
          )}
          {review.title && (
            <div className="review-vertical-title">
              {replaceTemplates(review.title)}
            </div>
          )}
          {review.text && (
            <div className="review-vertical-text">
              {replaceTemplates(review.text)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ReviewsVerticalElement;
